import { isEmpty } from "lodash";
import { useGlobalContext } from "../../../contexts"

import Link from "next/link";

export const PhoneLink = ({ className }) => {
  const { context } = useGlobalContext();
  const phone = context?.phone;
  if (isEmpty(phone?.number)) {
    return null;
  }

  return (
    <Link href={`tel:${phone?.number?.replace(/[\s()]/g, '')}`} className={`phone-link flex items-center justify-end gap-8 ${className}`}>
      <span className="icon-phone-call" />
      <span className="phone-banner-label whitespace-nowrap">{phone?.label}</span>
      <span className="phone-banner-number whitespace-nowrap">{phone?.number}</span>
    </Link>
  )
}